const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentLocationRow.tsx';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import textMap from '../translations';
import { useIntl } from 'react-intl';
import { IconTextTuple, IconTextTuples } from '../../DashboardPage/IconTextTuples';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';

type AppointmentLocationRowProps = {
    appointment: StructuredAppointment;
};

export const AppointmentLocationRow = (props: AppointmentLocationRowProps) => {
    const { appointment } = props;
    const { formatMessage } = useIntl();

    const iconTextTuplesStyles = {
        color: 'inherit',
        paddingVertical: 0,
    };

    const getLocationIconTuples = (): IconTextTuple[] => {
        const { RESSOURCENSTANDORT } = appointment;

        if (!RESSOURCENSTANDORT) {
            return [];
        }

        return [
            { icon: 'icons8-clinic', primaryText: RESSOURCENSTANDORT.Standort || '' },
            { icon: 'icons8-location', primaryText: RESSOURCENSTANDORT.Adresse || '' },
            { icon: 'icons8-phone', primaryText: RESSOURCENSTANDORT.TelefonStandort || '' },
        ].filter(({ primaryText }) => primaryText !== '');
    };

    const locationIconTuples = getLocationIconTuples();

    if (locationIconTuples.length === 0) return null;

    return (
        <Grid container size={{ xs: 12 }}>
            <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant={'h6'}>{formatMessage(textMap.contact)}</Typography>
                <div>
                    <IconTextTuples
                        styleIcon={iconTextTuplesStyles}
                        styleListItem={{
                            padding: 0,
                        }}
                        tuples={locationIconTuples}
                    />
                </div>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <div className="mapouter">
                    <div className="gmap_canvas">
                        <iframe
                            width="100%"
                            height="100%"
                            id="gmap_canvas"
                            src={`https://maps.google.com/maps?q=${appointment.RESSOURCENSTANDORT?.Adresse}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                            frameBorder="0"
                            scrolling="no"
                        />
                    </div>
                </div>
            </Grid>
        </Grid>
    );
};
